import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
  activeStyle: {
    borderRadius: 2,
    margin: "3px",
    height: 35,
    padding: "3px 7px",
    [theme.breakpoints.up(1024)]: {
      margin: "5px 10px",
      height: 40,
    },
    "&:first-child": {
      marginLeft: 3,
      [theme.breakpoints.up(1024)]: {
        marginLeft: 0,
      },
    },
    "&:last-child": {
      marginLeft: 3,
      [theme.breakpoints.up(1024)]: {
        marginLeft: 0,
      },
    },
  },
  inactiveStyle: {
    borderRadius: 2,
    height: 35,
    margin: "3px",
    padding: "0 5px",
    borderColor: theme.palette.colors.grey,
    transition: "0.2s all ease",
    [theme.breakpoints.up(1024)]: {
      margin: "5px 10px",
      height: 40,
    },
    "&:first-child": {
      marginLeft: 3,
      [theme.breakpoints.up(1024)]: {
        marginLeft: 0,
      },
    },
    "&:last-child": {
      marginLeft: 3,
      [theme.breakpoints.up(1024)]: {
        marginLeft: 0,
      },
    },
    [theme.breakpoints.up(768)]: {
      "&:hover": {
        backgroundColor: theme.palette.secondary.main,
        color: "#fff !important",
        cursor: "pointer",
      },
    },
  },
}));

export default function FilterButton(props) {
  const classes = useStyles();
  const setStyle =
    props.variant === "outlined" ? (
      <Chip
        label={props.label}
        className={classes.inactiveStyle}
        variant={props.variant}
        size={props.size}
        style={props.innerStyle}
      />
    ) : (
      <Chip
        label={props.label}
        className={classes.activeStyle}
        color="secondary"
        variant={props.variant}
        size={props.size}
        style={props.innerStyle}
      />
    );
  return setStyle;
}

FilterButton.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  size: PropTypes.string,
  innerStyle: PropTypes.object,
};

FilterButton.defaultProps = {
  size: "medium",
  innerStyle: undefined,
};
